import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Partner } from '../../types/partner';

export interface PartnerState {
  partners: Partner[];
  isLoading: boolean;
  error: {
    hasError: boolean;
    message: string;
    source: string | null;
    timestamp: number;
  } | null;
  success: {
    isSuccess: boolean;
    message: string;
    timestamp: number;
  } | null;
}

const initialState: PartnerState = {
  partners: [],
  isLoading: false,
  error: null,
  success: null,
};

export const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    setPartners: (state, action: PayloadAction<Partner[]>) => {
      state.partners = action.payload;
    },

    setRequestStatus: (state, action: PayloadAction<{ isLoading: boolean }>) => {
      const { isLoading } = action.payload;
      state.isLoading = isLoading;
    },

    setError: (
      state,
      action: PayloadAction<{
        message: string;
        source?: string;
      }>
    ) => {
      state.error = {
        hasError: true,
        message: action.payload.message,
        source: action.payload.source || null,
        timestamp: Date.now(),
      };
    },

    clearError: (state, action: PayloadAction<string | undefined>) => {
      if (!action.payload || state.error?.source === action.payload) {
        state.error = null;
      }
    },

    setSuccess: (state, action: PayloadAction<{ message: string }>) => {
      state.success = {
        isSuccess: true,
        message: action.payload.message,
        timestamp: Date.now(),
      };
    },

    clearSuccess: (state) => {
      state.success = null;
    },
  },
});

export const { setPartners, setRequestStatus, setError, clearError, setSuccess, clearSuccess } =
  partnerSlice.actions;

export default partnerSlice.reducer;
